export const normalizeBenchmark = (benchmark) => {
    if (!benchmark) return benchmark;
    if ('fixed_interest' in benchmark) return benchmark;
    return {
        id: benchmark.id,
        label: benchmark.label,
        cash: benchmark.cash,
        fixed_interest: benchmark.fixedInterest,
        property: benchmark.property,
        equity: benchmark.equity,
        uk_equity: benchmark.ukEquity,
        us_equity: benchmark.usEquity,
        european_equity: benchmark.euroEquity,
        fareast_equity: benchmark.fareastEquity,
        fareast_other_equity: benchmark.fareastOtherEquity,
        japan_equity: benchmark.japanEquity,
        other_equity: benchmark.otherEquity,
        specialist_equity: benchmark.specialistFundsEquity,
    };
};

export const getEquity = (data, needle) => {
    let equities = [];
    let sum = 0.0;

    for (const k in data) {
        if (k.includes(needle)) {
            equities[k] = parseFloat(data[k]).toFixed(2);
            sum += parseFloat(data[k]);
        }
    }

    return {
        equity: equities,
        total: parseFloat(sum).toFixed(2),
    };
};

export const totalChecker = (data) => {
    let sum = 0.0;
    for (const k in data) {
        if (k !== 'allocation' && typeof data[k] === 'number') {
            sum += data[k];
        } else if (k !== 'allocation') {
            sum += parseFloat(data[k]);
        }
    }

    return sum === 100;
};

export const getVariance = (setA, setB) => {
    const aKeys = Object.keys(setA).sort();
    const bKeys = Object.keys(setB).sort();
    if (JSON.stringify(aKeys) !== JSON.stringify(bKeys)) {
        return {};
    }

    let variation = {};
    for (let i = 0; i < aKeys.length; i++) {
        variation[aKeys[i]] = (parseFloat(setA[aKeys[i]]) - parseFloat(setB[aKeys[i]])).toFixed(2);
    }
    variation['allocation'] = 'variance';

    return variation;
};

export const sortDataForDisplay = (data, addType = true) => {
    const order = ['pension', 'nonpension', 'all'];
    let customSort = [];
    for (const v of order) {
        if (addType) {
            customSort.push({ ...data[v], type: v });
        } else {
            customSort.push({ ...data[v] });
        }
    }

    return customSort;
};

export const calculatePolicyTotalsForCollapsedView = (policyPayload) => {
    const toReturn = [];

    for (let policy in policyPayload) {
        toReturn[policy] = {
            value: 0.0,
            cash: 0.0,
            cash_percent: 0.0,
            fixed_interest: 0.0,
            fixed_interest_percent: 0.0,
            property: 0,
            property_percent: 0.0,
            equity: 0.0,
            uk_equity: 0.0,
            equity_percent: 0.0,
            us_equity: 0.0,
            european_equity: 0.0,
            fareast_equity: 0.0,
            fareast_other_equity: 0.0,
            japan_equity: 0.0,
            other_equity: 0.0,
            specialist_equity: 0.0,
            uk_equity_percent: 0.0,
            us_equity_percent: 0.0,
            european_equity_percent: 0.0,
            fareast_equity_percent: 0.0,
            fareast_other_equity_percent: 0.0,
            japan_equity_percent: 0.0,
            other_equity_percent: 0.0,
            specialist_equity_percent: 0.0,
        };

        policyPayload[policy].forEach((fund) => {
            toReturn[policy]['value'] += parseFloat(fund.value);
            for (const [key, value] of Object.entries(fund.allocation)) {
                if (key !== 'sector' && value && value !== 'undefined' && value !== null) {
                    switch (typeof value) {
                        case 'string':
                            toReturn[policy][key] = toReturn[policy][key] += parseFloat(value);
                            break;
                        case 'number':
                            toReturn[policy][key] = toReturn[policy][key] += value;
                            break;
                    }
                }
            }
        });
    }

    return toReturn;
};
